import { FC, useEffect } from "react";
import { Container } from "react-bootstrap";

const Footer: FC = () => {
    return (
        <>
            <footer>
                <Container>
                    <p className="m-0 text-center">© {new Date().getFullYear()} National Acoustic Laboratories. All rights reserved.</p>
                </Container>
            </footer>
        </>
    )
}
export default Footer;